export var MessagingRequestType;
(function (MessagingRequestType) {
    MessagingRequestType["TEXT_MESSAGE"] = "TEXT_MESSAGE";
    MessagingRequestType["INFO_TALK"] = "INFO_TALK";
})(MessagingRequestType || (MessagingRequestType = {}));
